import { useCallback, useState } from 'react';
import { defaultLimit } from 'views/CRM/shared/utils/pagination';
import notPurchasedService from '../services/notPurchasedReportService';

export const useListRegisters = ({ recordTypeId, sortConfig }) => {
  const [registers, setRegisters] = useState();
  const [totalRegisters, setTotalRegisters] = useState();
  const [isLoadingRegisters, setIsLoadingRegisters] = useState(false);

  const getRegisters = useCallback(
    (page = 1, params = {}) => {
      setIsLoadingRegisters(true);
      params.page = page;
      params.limit = defaultLimit;

      const orderType =
        sortConfig?.direction === null ||
          sortConfig?.direction === undefined ||
          // Algumas páginas estão passando `ascending` enquanto outras passam `ascendant`. Para evitar modificar muitos arquivos, aceita-se ambos os modos.
          (sortConfig?.direction === 'ascending' || sortConfig?.direction === 'ascendant')
          ? 'ASC'
          : 'DESC';

      const orderBy = sortConfig?.key;

      notPurchasedService
        .getRegisters(recordTypeId, { ...params, orderType, orderBy })
        .then((response) => {
          setRegisters(response.data.data);
          setTotalRegisters(response.data.totalRegisters);
        })
        .finally(() => setIsLoadingRegisters(false));
    },
    [recordTypeId, sortConfig]
  );

  const clearRegisters = useCallback(() => {
    setRegisters(null);
    setTotalRegisters(0);
    setIsLoadingRegisters(false);
  }, []);

  return {
    registers,
    totalRegisters,
    isLoadingRegisters,
    getRegisters,
    clearRegisters
  };
};
